import { fetchProcessDiagram, saveBlob } from "./useCaseDiagramService";

// UML activity diagram for a process: swimlanes per Responsible job, task
// flow, and gateways as fork/join or decision/merge.

// format: "png" (2x resolution by default) or "svg"
export function getActivityDiagram(processId, format = "png") {
  return fetchProcessDiagram("/activity-diagram", processId, format);
}

// format: "png", "svg" or "report" (Markdown)
export async function downloadActivityDiagram(processId, format, fileName) {
  const blob = await getActivityDiagram(processId, format);
  const ext = format === "report" ? "md" : format;
  saveBlob(blob, fileName || `activity-diagram-${processId}.${ext}`);
}
